<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <div class="row y-gap-15 justify-between items-center">
        <div class="col-auto">
          <div v-html="vars.titleHtml"></div>
        </div>
        <div class="col-lg-6 col-md-9 tw-hidden lg:tw-block">
          <p v-for="(item, index) in items" :key="index" class="tw-mb-2">
            {{ item.description }}
          </p>
        </div>
      </div>

      <div data-anim-wrap class="row y-gap-30 pt-60 md:pt-30 tw-hidden lg:tw-flex">
        <div class="col-lg-3 col-sm-6" v-for="(team, index) in teams" :key="index">
          <div class="teamCard -type-1 tw-group" :data-anim-child="`slide-left delay-${index + 1}`">
            <div class="tw-overflow-hidden">
              <library-image
                v-if="team.photo"
                :src="team.photo"
                class="tw-transition-all tw-duration-500 group-hover:tw-scale-110"
                :alt="team.title || team.name"
                :w-ratio="5"
                :h-ratio="7"
              />
            </div>
            <div class="mt-3">
              <h4>{{ team.name }}</h4>
            </div>
            <div class="mt-1">
              <h5 :style="{ color: 'var(--c-secondary)' }">
                {{ team.role }}
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider lg:tw-hidden"
        data-anim="slide-left"
        data-gap="30"
        data-slider-cols="xl-3 lg-2 md-1 sm-1 base-1"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(team, index) in teams" :key="`latestblogs-blog-${index}`">
            <div class="teamCard">
              <div>
                <library-image
                  v-if="team.photo"
                  :src="team.photo"
                  :alt="team.title || team.name"
                  :w-ratio="5"
                  :h-ratio="7"
                />
              </div>
              <div class="mt-3">
                <h4>{{ team.name }}</h4>
              </div>
              <div class="mt-1">
                <h5 :style="{ color: 'var(--c-secondary)' }">
                  {{ team.role }}
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center min-[1024px]:!tw-hidden">
          <button
            class="sliderNav -prev js-prev n-link !tw-bg-transparent !tw-text-black"
            style="border-color: black !important"
          >
            <i class="icon-left-arrow"></i>
          </button>
          <button
            style="border-color: black !important"
            class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent !tw-text-black"
          >
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Popup from '~/components/common/popup/Popup.vue';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'OurTeam',

  mixins: [ComponentMixin],

  components: { Popup },

  data() {
    return {
      selectedTeam: null as any | null,
      popupConfig: {
        isActive: false,
      },
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
    };
  },

  computed: {
    teams(): any[] {
      return this.groupedVariables?.teams || [];
    },
    items() {
      return this.groupedVariables?.items || [];
    },

    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },

  mounted() {
    this.onSlideChange();
  },

  methods: {
    toggleTeamDetailPopup(team: any | null = null, value = false): void {
      if (team) {
        this.selectedTeam = team;
        this.popupConfig.isActive = value;
      }
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
});
</script>

<style scoped>
.team-member-popup {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  overflow: hidden;
  background-color: white;
}

.team-member-image-placeholder {
  background-color: #9a9a9a;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .team-member-popup {
    max-width: 90%;
  }
}
</style>
